'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This document is the property of Nettoken Ltd.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * It is considered confidential and proprietary.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This document may not be reproduced or transmitted in any form,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * in whole or in part, without the express written permission of
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Nettoken Ltd.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _immutable = require('immutable');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Model = function () {
  /**
   * @param {object} state Initial model state.
   */
  function Model(state) {
    _classCallCheck(this, Model);

    if (!state) state = {};

    if ((typeof state === 'undefined' ? 'undefined' : _typeof(state)) !== 'object' || Array.isArray(state)) {
      throw new Error('State must be an object');
    }

    this.keys = new _immutable.List(Object.keys(state));
    this.state = new _immutable.Map(state);
    this._isModel = true;
  }

  /**
   * Filter the model state and return only selected keys.
   *
   * @param {array} keys
   * @param {...string} args
   */


  _createClass(Model, [{
    key: 'filter',
    value: function filter() {
      var _this = this;

      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      keys = new _immutable.List(Array.isArray(keys) ? keys : [keys].concat(args));
      var state = new _immutable.Map();
      keys.forEach(function (key) {
        state = state.set(key, _this.get(key));
      });
      return state.toJS();
    }

    /**
     * Return current value of given key.
     *
     * @param {string} key Requested attribute.
     */

  }, {
    key: 'get',
    value: function get(key) {
      if (!this.state.has(key)) {
        this._warnInvalidKeyRead(key);
      }
      return this.state.get(key);
    }

    /**
     * Return the correct model state in plain JavaScript.
     */

  }, {
    key: 'getState',
    value: function getState() {
      return this.state.toJS();
    }
  }, {
    key: 'set',
    value: function set(key, value) {
      if (!this._isValidKey(key)) {
        this._warnInvalidKeyWrite(key);
      } else {
        this.state = this.state.set(key, value);
      }
    }
  }, {
    key: 'setState',
    value: function setState(nextState) {
      var overrideFalsyValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.state = this.state.merge(this._sanitizeState(nextState, overrideFalsyValues));
    }

    /**
     * Validates model values against passed conditions.
     *
     * @param {array} conditions An array of test cases.
     *
     * @returns {null} There were no errors.
     * @returns {array} Array of error objects.
     */

  }, {
    key: 'validate',
    value: function validate() {
      var _this2 = this;

      var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var errors = new _immutable.List();

      conditions.forEach(function (row) {
        // Exit on first error.
        for (var i = 0; i < row.tests.length; i += 1) {
          var test = row.tests[i];
          var value = _this2.get(row.key);
          if (!test.check(value)) {
            var forElement = row.forElement || row.key;
            var message = test.error();
            errors = errors.push({ forElement: forElement, message: message, value: value });
            break;
          }
        }
      });

      return errors.size > 0 ? errors.toArray() : null;
    }
  }, {
    key: '_isValidKey',
    value: function _isValidKey(key) {
      return this.keys.includes(key);
    }
  }, {
    key: '_sanitizeState',
    value: function _sanitizeState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var overrideFalsyValues = arguments[1];

      Object.keys(state).forEach(function (key) {
        // Remove keys that are not part of the schema.
        if (!_this3._isValidKey(key)) {
          _this3._warnInvalidKeyWrite(key);
          delete state[key];
        }
        // We blocked overwriting falsy values.
        if (!overrideFalsyValues && _this3.state.get(key)) {
          delete state[key];
        }
      });
      return state;
    }
  }, {
    key: '_warnInvalidKeyRead',
    value: function _warnInvalidKeyRead(key) {
      console.warn('Accessing unknown key "' + key + '", it will be always undefined.');
    }
  }, {
    key: '_warnInvalidKeyWrite',
    value: function _warnInvalidKeyWrite(key) {
      console.warn('Attempting to set unknown key "' + key + '", it will be ignored.');
    }
  }]);

  return Model;
}();

exports.default = Model;